/**
 * Service: discounts
 */
angular.module('acme.common.service.discounts', [])
.service('DiscountsService', [ '$rootScope', function($rootScope) {

    return {

      model: [],

      init: function() {
        return true;
      },

      setModel: function(discounts) {
        if (discounts instanceof Array) {
          this.model = discounts;
        }
        $rootScope.$broadcast('DiscountsService::Update');
      },

      getModel: function() {
        return this.model;
      },

      find: function(id) {
        var i, ii,
          r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (id === this.model[i].id) {
            r = {
              index: i,
              code: this.model[i]
            };
            break;
          }
        }

        return r;
      }

    };

}]);